import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { RootState, MyThunkDispatch } from 'store';

import { fetchUserAccount } from 'actions/user';
import useStoreTranslation from 'hooks/useStoreTranslation';
import useToast from 'hooks/useToast';
import useUserAccount from 'hooks/useUserAccount';
import TravelerProfile from 'screens/components/TravelerProfile';
import { extractErrorMessage, base64ToFile } from 'utils/generic';

import { getPhoto } from '../../services/photoProfileService';

const TravelerProfileContainer = () => {
  const dispatch: MyThunkDispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [profilePhoto, setProfilePhoto] = useState('');
  const toast = useToast();
  const { t } = useStoreTranslation();

  const {
    user: { accountResult },
  } = useSelector((state: RootState) => state);

  const getAccount = () => dispatch<any>(fetchUserAccount());

  const fetchTravelerUser = async () => {
    try {
      setIsLoading(true);
      await getAccount();

      try {
        const responsePhoto = await getPhoto();

        if (responsePhoto.succeeded && responsePhoto.data.picture) {
          const file = await base64ToFile(
            `data:text/plain;base64,${responsePhoto.data.picture}` as string,
            responsePhoto.data.extension,
          );
          const reader = new FileReader();
          reader.readAsDataURL(file as File);
          reader.onload = () => {
            setProfilePhoto(reader.result as string);
          };
        }
      } catch (e) {}

      setIsLoading(false);
    } catch (error) {
      toast.add({ type: 'danger', message: extractErrorMessage(error) || t('defaultError.default') });
    } finally {
      setIsLoading(false);
    }
  };

  const companyId = accountResult ? accountResult.companyId : '';
  const id = accountResult ? accountResult.id : '';

  useEffect(() => {
    fetchTravelerUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const user = useUserAccount();

  const data = {
    id,
    user,
    isLoading,
    companyId,
  };

  return <TravelerProfile image={profilePhoto} setLoading={setIsLoading} {...data} />;
};

export default TravelerProfileContainer;
